import { Button } from "reactstrap";

export default function FormActions({
  currentStep,
  totalSteps,
  isSubmitting,
  onBack,
  onNext,
  formik,  
}) {
  const { errors, isValid } = formik;
  const hasErrors = Object.keys(errors).length > 0;

  return (
    <div className="d-flex justify-content-between mt-4 border-none">
      {currentStep > 0 && (
        <Button type="button" color="light" onClick={onBack}>
          Previous
        </Button>
      )}

      {currentStep < totalSteps - 1 && (
        <Button
          type="button"
          color="primary"
          onClick={onNext}
          disabled={isSubmitting || hasErrors || !isValid}
          style={{ border: "none" }}
        >
          Next
        </Button>
      )}

      {currentStep === totalSteps - 1 && (
        <Button
          type="submit"
          color="success"
          disabled={isSubmitting || hasErrors || !isValid}
        >
          {isSubmitting ? "Redirecting..." : "View all forms"}
        </Button>
      )}
    </div>
  );
}
